import auth from './auth';
import common from './common';
export default {
    auth,
    common
};
